import { Grid, Stack, Typography } from '@mui/material';
import { memo } from 'react';
import share_logo from '../images/SHARE__Logo.png';
import usaid_logo from '../images/USAID_VERTICAL.png';

const AcknowledgementsScreen = () => {
    return (
        <Stack
            sx={{
                rowGap: 4,
                padding: { xs: 4, md: 10 },
            }}
        >
            <Grid
                container
                sx={{
                    alignItems: 'center',
                    justifyContent: 'space-evenly',
                }}
            >
                <Grid>
                    <img
                        alt="usaid logo"
                        src={usaid_logo}
                        style={{
                            height: '13rem',
                            width: '13rem',
                            objectFit: 'contain',
                            marginLeft: '-1.5rem',
                        }}
                    />
                </Grid>
                <Grid>
                    <img
                        alt="share logo"
                        src={share_logo}
                        style={{ height: '5rem', width: '13rem', objectFit: 'contain' }}
                    />
                </Grid>
            </Grid>
            <Typography variant="subtitle1">
                The Children's Responses to Emotional and Social Situations (CREST) app was created
                as part of the Supporting Holistic and Actionable Research in Education (SHARE)
                initiative. SHARE is a cooperative agreement (No. 7200AA20CA00025) between USAID and
                the University of Notre Dame (UND). UND is implementing the SHARE activity in
                partnership with local higher education and research institutions. Through SHARE,
                and together with its partners, UND will advance USAID's Learning Priorities in the
                global education sector as a global good to improve education and learning outcomes.
                The CREST app was produced as part of the Contextually Relevant Emotional and Social
                Wellbeing Tools (CREST) study.
            </Typography>
            <Typography variant="subtitle2">
                The CREST app development team is as follows:
            </Typography>
            <ul style={{ marginTop: '-1rem' }}>
                <li>
                    <Typography>Project management: Aimee Lyons</Typography>
                </li>
                <li>
                    <Typography>Assessment requirements and design: Nikhit D'Sa</Typography>
                </li>
                <li>
                    <Typography>
                        Digital app development and testing: Luke Weisensee, Pat Weisensee, and John
                        Loughran
                    </Typography>
                </li>
                <li>
                    <Typography>Graphics: Claire Kirner</Typography>
                </li>
                <li>
                    <Typography>
                        Review and support: Brianna Conaghan, Mariana Arboleda Florez, Juan David
                        Parra Heredia, Jeongmin Lee, Camilo Vieira Mejia, and Jean Marc Tiendrebeogo
                    </Typography>
                </li>
                <li>
                    <Typography>
                        Pilot testing and contextualization in Haiti: Michel Eugène and Raynold
                        Billy
                    </Typography>
                </li>
                <li>
                    <Typography>
                        Pilot testing and contextualization in Honduras: German Moncada and Russbel
                        Hernandez
                    </Typography>
                </li>
                <li>
                    <Typography>
                        Pilot testing and contextualization in Liberia: Yarvo J. Boakai and David
                        Baysah
                    </Typography>
                </li>
            </ul>
            {/* <Link
                target="_blank"
                color="secondary"
                href="https://iei.nd.edu/initiatives/gc-dwc/SHARE"
                sx={{ width: 300 }}
            >
                See SHARE website for more information
            </Link> */}
            <Typography variant="subtitle1">
                The CREST app was inspired and influenced by the Childhood Assessment Tool-
                Electronic (CHAT-E) app created by Terri J. Sabol, Andrea Kinghorn Busby, and Marc
                W. Hernandez. We are thankful for their guidance and support, and for agreeing to
                let us build on CHAT-E to create the CREST app.
            </Typography>

            {/* <Link
                sx={{ width: 300 }}
                target="_blank"
                color="secondary"
                href="https://sites.northwestern.edu/deep/"
            >
                See DEEP website for more information
            </Link> */}
        </Stack>
    );
};

export default memo(AcknowledgementsScreen);
